module.exports = __webpack_public_path__ + "img/USB.4e0f9f7e.svg";